import React from "react";
import { useParams, Navigate, Link } from "react-router-dom";
import Layout from "../components/Layout";
import { useAuth } from "../contexts/AuthContext";
import SettingsLayout from "./innstillinger/SettingsLayout";
import KontoPage from "./innstillinger/KontoPage";
import ProfilPage from "./innstillinger/ProfilPage";
import MeldingerPage from "./innstillinger/MeldingerPage";
import VennerPage from "./innstillinger/VennerPage";
import InnholdPage from "./innstillinger/InnholdPage";
import BlokkeringPage from "./innstillinger/BlokkeringPage";
import VarslerPage from "./innstillinger/VarslerPage";
import SprakPage from "./innstillinger/SprakPage";
import KampanjekoderPage from "./innstillinger/KampanjekoderPage";

const SECTIONS = {
  konto: KontoPage,
  profil: ProfilPage,
  meldinger: MeldingerPage,
  venner: VennerPage,
  innhold: InnholdPage,
  kampanjekoder: KampanjekoderPage,
  blokkering: BlokkeringPage,
  varsler: VarslerPage,
  sprak: SprakPage,
};

export default function Innstillinger() {
  const { user } = useAuth();
  const { section } = useParams();

  if (user === false || user === null) {
    return (
      <Layout>
        <div className="font-fraunces italic text-[var(--cream-soft)]">
          <Link to="/login" className="text-[var(--magenta)]">Logg inn</Link> for å justere innstillinger.
        </div>
      </Layout>
    );
  }

  if (!section) {
    return <Navigate to="/innstillinger/konto" replace />;
  }

  const Page = SECTIONS[section];
  if (!Page) {
    return <Navigate to="/innstillinger/konto" replace />;
  }

  return (
    <SettingsLayout active={section}>
      <Page />
    </SettingsLayout>
  );
}
